import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  reload(): void {
    // Hard reload re-runs bootstrap + guards from a clean state; the most
    // reliable recovery when the SPA landed here from an aborted navigation.
    window.location.assign('/');
  }
}
